<template>
  <div id="app">
    <CssFusion />
  </div>
</template>

<script>
import CssFusion from './components/CssFusion.vue'

export default {
  name: 'app',
  components: {
    CssFusion
  }
}
</script>

<style src="@/assets/css/fusion.css"></style>
